export const EMAILTEXTBODY: string = `Hello,
Please find attached all relevant information for the upcoming cruise and associated services.
We kindly ask you to review the attached PDFs carefully and in full, as they contain important operational details.
To ensure smooth coordination, we ask that you confirm receipt of this message & everything is in order/correct.
Should you have any questions or require clarification, feel free to reach out to us at any time.
Best regards,`;
export const EMAILHTMLBODY: string = `<p style="font-family: poppins;">Hello,<br>
Please find attached all relevant information for the upcoming cruise and associated services.<br>
We kindly ask you to review the attached PDFs <span style="font-weight:bold;">carefully and in full</span>, as they contain important operational details.<br>
To ensure smooth coordination, we ask that you <span style="font-weight:bold;">confirm receipt</span> of this message & everything is in order/correct.<br>
Should you have any questions or require clarification, feel free to reach out to us at any time.<br>
Best regards,<br></p>`;
